import { Box } from 'bonfire-kindling';

import Step from 'components/Step/Step';
import StepConnector from 'components/StepConnector/StepConnector';

const Stepper = ({
  completeIndex,
  onClick,
  steps,
  activeIndex,
  connectorComponent = StepConnector,
  stepComponent = Step,
}) => {
  const nodes = [];

  const isNotAllowed = i => completeIndex === null || i > completeIndex + 1;

  function handleClick(i) {
    if (isNotAllowed(i)) return;
    onClick(i);
  }
  const StepComponent = stepComponent;
  const ConnectorComponent = connectorComponent;

  for (let i = 0; i < steps.length; i += 1) {
    nodes.push(
      <StepComponent
        isActive={i === activeIndex}
        isComplete={completeIndex !== null && i <= completeIndex}
        isNotAllowed={isNotAllowed(i)}
        onClick={() => handleClick(i)}
        key={i}
        index={i}
        {...steps[i]}
      />
    );
    nodes.push(<ConnectorComponent key={`connector-${i}`} />);
  }

  nodes.pop();

  return (
    <Box
      component="nav"
      display="flex"
      alignItems="center"
      sx={{
        color: theme => theme.palette.purple.main,
        borderColor: theme => theme.palette.purple.main,
      }}
    >
      {nodes}
    </Box>
  );
};

export default Stepper;
